import React from "react";
import { BrowserRouter, HashRouter, Routes, Route } from 'react-router-dom';
import Login from "./login";
import Register from "./register";
import AuthenticatedRoute from "components/auth";
import { Dashboard } from "components/dashboard";
import { FileUpload } from "components/upload";
import { NotFound } from "./404";
import { Vw_Samithi_Members, Samithi_Members, Gramam, Vw_Zilla, Vw_Nagar_Khanda, Vw_Members, Zilla, Vibhag, Nagar_Khanda, Members, Desig_Level, Designation, Blood_Grp, JillaReport } from "components";
import { NagarKhandaReports } from "components/nagar_khanda_reports";
import { UpmandalBasthiReports } from "components/upmandal_basthi_reports";
import { Samithi_MembersForm } from "components/samithi_members/form";
import { GramamReport } from "components/gramam_reports";
import { PranthaSthayiCards } from "components/prantha_sthayi_reports/PranthaSthayiReportsCards";
const Pages: React.FC = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/admin" element={<Login />}>
        </Route>
        {/* <Route path="/register" element={<Register />}>
        </Route> */}
        {/* <Route path="/dashboard" element={<AuthenticatedRoute element={<Dashboard />} />}></Route> */}
        {/* <Route path="/upload" element={<AuthenticatedRoute element={<FileUpload />} />}></Route> */}
        <Route path="/vw_zilla" element={<AuthenticatedRoute element={<Vw_Zilla />} />}></Route>
        <Route path="/vw_nagar_khanda" element={<AuthenticatedRoute element={<Vw_Nagar_Khanda />} />}></Route>
        <Route path="/vw_members" element={<AuthenticatedRoute element={<Vw_Members />} />}></Route>
        <Route path="/vibhag" element={<AuthenticatedRoute element={<Vibhag />} />}></Route>
        <Route path="/vw_samithi_members" element={<AuthenticatedRoute element={<Vw_Samithi_Members />} />}></Route>
        {/* <Route path="/addsamithi_member" element={<AuthenticatedRoute element={<Samithi_MembersForm />} />}></Route> */}
        <Route path="/samithi_members/:id" element={<AuthenticatedRoute element={<Samithi_Members  />} />}></Route>
        <Route path="/vibhagreports" element={<AuthenticatedRoute element={<Dashboard />} />}></Route>
        {/* <Route path="/dashboardreports" element={<AuthenticatedRoute element={<PranthaSthayiCards />} />}></Route> */}
        <Route path="/jillareports/:id" element={<AuthenticatedRoute element={<JillaReport />} />}></Route>
        {/* <Route path="/jillareports" element={<AuthenticatedRoute element={<JillaReport />} />}></Route> */}

        <Route path="/nagarkhandareports/:id" element={<AuthenticatedRoute element={<NagarKhandaReports />} />}></Route>
        <Route path="/upmandalbasthireports/:id" element={<AuthenticatedRoute element={<UpmandalBasthiReports />} />}></Route>
        <Route path="/gramamreports/:id" element={<AuthenticatedRoute element={<GramamReport />} />}></Route>

        <Route path="/gramam" element={<AuthenticatedRoute element={<Gramam />} />}></Route>
        {/* GramamReport<Route path="/zilla" element={<AuthenticatedRoute element={<Zilla />} />}></Route>

<Route path="/nagar_khanda" element={<AuthenticatedRoute element={<Nagar_Khanda />} />}></Route> */}
        {/* <Route path="/" element={<AuthenticatedRoute element={<Members />} />}></Route> */}

        <Route path="/desig_level" element={<AuthenticatedRoute element={<Desig_Level />} />}></Route>
        <Route path="/designation" element={<AuthenticatedRoute element={<Designation />} />}></Route>
        <Route path="/blood_grp" element={<AuthenticatedRoute element={<Blood_Grp />} />}></Route>
        <Route path="/register" element={<Members />}></Route>
        {/* <Route path="/" element={<Members />}></Route> */}
        <Route path="/" element={<AuthenticatedRoute element={<Samithi_Members />} />}></Route>



      </Routes>
    </HashRouter>
  );
};

export default Pages;
